export default __webpack_public_path__ + "static/media/truck.cc8465a3.png";